export default __webpack_public_path__ + "static/media/map_bg.6bdea411.jpg";